export const environment = {
  name: 'stag',
  production: false,
  tokenStorage: 'sessionStorage',
  backendUrl: 'https://sr-psa-icadp.branderideas.com'
} as const;
